import { useQuery } from "@tanstack/react-query";

import TwilioPhoneNumberService from "services/TwilioPhoneNumber";

export function useHoldMessageLanguages() {
  const { data: languages = [], isLoading } = useQuery({
    queryKey: ["twilio-hold-message-languages"],
    queryFn: () => TwilioPhoneNumberService.getHoldMessageLanguages(),
    staleTime: Infinity,
  });

  return { languages, isLoading };
}
